import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
export function cn(...inputs) {
    const twMerge = extendTailwindMerge({
        extend: {
            classGroups: {
                "font-size": [
                    "text-8",
                    "text-9",
                    "text-10",
                    "text-11",
                    "text-13",
                    "text-15",
                    "text-17",
                    "text-22",
                    "text-26",
                    "text-27",
                    "text-0.75",
                    "text-3.5xl",
                    "text-0.85",
                ],
            },
        },
    });
    return twMerge(clsx(inputs));
}
